import React, { useState } from 'react';
import { API, C } from '../constants';

export default function AuthScreen({ onAuth }) {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name:'', email:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = async () => {
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}${mode === 'login' ? '/auth/login' : '/auth/register'}`, {
        method:'POST', headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Error'); setLoading(false); return; }
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onAuth(data.token, data.user, data.profiles || []);
    } catch { setError('No se pudo conectar al servidor'); }
    setLoading(false);
  };
  const inp = { width:'100%', padding:'14px 18px', borderRadius:'10px', background:'rgba(255,255,255,0.04)', border:`1px solid ${C.accentBorder}`, color:C.text, fontSize:'15px', outline:'none', boxSizing:'border-box', marginBottom:'14px', fontFamily:'Inter, sans-serif' };
  return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
      <div style={{ marginBottom:'40px', textAlign:'center' }}>
        <h1 style={{ fontFamily:'Playfair Display, serif', fontSize:'42px', fontWeight:'700', color:C.accentSoft, letterSpacing:'2px' }}>TLALLI</h1>
        <p style={{ color:C.textMuted, fontSize:'13px', marginTop:'6px', letterSpacing:'3px', textTransform:'uppercase' }}>Cinema en casa</p>
      </div>
      <div style={{ width:'100%', maxWidth:'420px', padding:'0 24px' }}>
        <div style={{ background:C.bgCard, borderRadius:'20px', padding:'40px', border:`1px solid ${C.border}`, boxShadow:'0 24px 64px rgba(0,0,0,0.6)' }}>
          <h2 style={{ fontFamily:'Playfair Display, serif', color:C.text, fontSize:'22px', fontWeight:'600', marginBottom:'28px' }}>
            {mode === 'login' ? 'Bienvenido de vuelta' : 'Crear cuenta'}
          </h2>
          {mode === 'register' && <input name="name" placeholder="Nombre completo" value={form.name} onChange={handle} style={inp} />}
          <input name="email" placeholder="Correo electrónico" type="email" value={form.email} onChange={handle} style={inp} />
          <input name="password" placeholder="Contraseña" type="password" value={form.password} onChange={handle} style={inp} onKeyDown={e => e.key === 'Enter' && submit()} />
          {error && <p style={{ color:'#e07a5f', fontSize:'14px', marginBottom:'14px', textAlign:'center' }}>{error}</p>}
          <button onClick={submit} disabled={loading} style={{ width:'100%', padding:'14px', borderRadius:'10px', background:loading ? C.textDim : `linear-gradient(135deg, ${C.accent}, ${C.accentSoft})`, border:'none', color:'#fff', fontSize:'15px', fontWeight:'600', cursor:loading ? 'not-allowed' : 'pointer', marginBottom:'24px', fontFamily:'Inter, sans-serif' }}>
            {loading ? 'Cargando...' : mode === 'login' ? 'Entrar' : 'Registrarse'}
          </button>
          <p style={{ color:C.textMuted, fontSize:'14px', textAlign:'center' }}>
            {mode === 'login' ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'}
            <span onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }} style={{ color:C.accentSoft, cursor:'pointer', marginLeft:'6px', fontWeight:'600' }}>
              {mode === 'login' ? 'Regístrate' : 'Inicia sesión'}
            </span>
          </p>
        </div>
      </div>
      <p style={{ color:C.textDim, fontSize:'12px', marginTop:'40px', letterSpacing:'1px' }}>© 2026 TLALLI · Todos los derechos reservados</p>
    </div>
  );
}
